import { v4 as UUID } from 'uuid'

import {
  Policy_FeeCalculationMethodEnum,
  Policy_KindEnum,
  Policy_PenaltyFrequencyEnum,
  Policy_StatusEnum,
  AgencySettings_VehicleStatesEnum,
  IpoliciesListLightProps,
  IpoliciesExportProps,
  Policy_MaintenanceKindsEnum,
} from 'src/api/gen'
import { Policy } from 'src/api/types/policy'
import { IAgencySettingsContext } from 'src/layout/AgencySettings'
import SETTINGS from 'src/settings'

import { TemporalNow } from '../temporalHelpers'

import { initialiseRule } from './rules'

export function getInitialPolicyConfig(kind: Policy_KindEnum): Policy['config'] {
  switch (kind) {
    case Policy_KindEnum.balancing:
      return {
        minimum_fleet_percentage: 0,
      }
  }
  return {}
}

export const getInitialPolicy = (agencySettings: IAgencySettingsContext, id: string, kind: Policy_KindEnum): Policy => {
  const initialPolicy: Policy = {
    id,
    name: '',
    status: Policy_StatusEnum.ongoing,
    description: '',
    providers: [],
    start_date: TemporalNow().startOfDay(),
    end_date: undefined,
    published_date: undefined,
    prev_policies: [],
    config: getInitialPolicyConfig(kind),
    rules: [initialiseRule(kind)] as any,
    kind: kind as any,
    areas: [],
    confirmation_delay: 0,
    penalty_delay: 0,
    penalty_frequency:
      [
        Policy_KindEnum.absolute_fleet_size,
        Policy_KindEnum.geofence,
        Policy_KindEnum.speed,
        Policy_KindEnum.parking,
        Policy_KindEnum.dwell_time,
      ].includes(kind) && SETTINGS.app.enable_timeslots
        ? Policy_PenaltyFrequencyEnum.hourly
        : Policy_PenaltyFrequencyEnum.daily,
    penalty_amount: 0,
    fixed_price: 0,
    flat_penalty: 0,
    minimum_time_duration: 0,
    fee_calculation_method: kind == Policy_KindEnum.trip_taxation ? Policy_FeeCalculationMethodEnum.lowest : undefined,
    // Setting vehicle_events_and_states here is needed in case the configure button is never clicked
    vehicle_events_and_states: agencySettings.vehicle_state_events?.[kind] ?? {},
    notification_delay: undefined,
    smart_patrol: false,
    maintenance_kinds: undefined,
    is_mds: true,
  }

  switch (kind) {
    case Policy_KindEnum.dwell_time:
      initialPolicy.confirmation_delay = 24
      initialPolicy.notification_delay = 24
      initialPolicy.vehicle_events_and_states = {
        [AgencySettings_VehicleStatesEnum.available]: [],
        [AgencySettings_VehicleStatesEnum.non_operational]: [],
        [AgencySettings_VehicleStatesEnum.reserved]: [],
      }
      break
    case Policy_KindEnum.maintenance:
      initialPolicy.maintenance_kinds = [Policy_MaintenanceKindsEnum.warehouse, Policy_MaintenanceKindsEnum.on_street]
      break
  }

  return initialPolicy
}

export const duplicatePolicy = function (policy: Policy, duplicated_policy_start_of_name: string): void {
  policy.id = ''
  policy.published_date = undefined
  policy.name = `${duplicated_policy_start_of_name} - ${policy.name}`
  policy.start_date = TemporalNow().startOfDay()
  for (const rule of policy.rules) {
    rule.rule_id = UUID()
  }
}

export interface IPoliciesListFilters {
  kind: Policy_KindEnum[]
  name: string
  providers: string[]
  status: Policy_StatusEnum[]
}

export const filters_to_request_params = function (
  filters: IPoliciesListFilters,
  defaultFilters: IPoliciesListFilters
): IpoliciesListLightProps | IpoliciesExportProps {
  return {
    ...filters,
    kind: filters.kind.length ? filters.kind : defaultFilters.kind,
  }
}
